module.exports = __webpack_public_path__ + "static/media/Frame 1.7c53c6e8.png";